module.exports = __webpack_public_path__ + "static/media/icon-track-assignment-assigned-by-others.2625008f.svg";